import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';

export const LazyHeaderAndFooterPage: LoadableType<{}> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-HeaderAndFooterContainer" */ '../src/HeaderAndFooter/HeaderAndFooterPage.tsx'
			)
		).HeaderAndFooterPage,
});
